import React from "react";
// import { FeatureFlag } from "react-unleash-flags";
import { Text } from "@networkraildigitalfactory/components";
import styles from "./ViewReviewPrep.module.css";

const RatingBox = (props) => {
  const { heading, message } = props;
  return (
    <div name="performance-ratings">
      <div className={styles.RatingBox}>
        <Text wrapper="h3" type="header" style={{ fontSize: "20px", margin: 0 }}>
          {heading}
        </Text>
        {message && (
          <Text
            wrapper="span"
            type="body"
            style={{ fontSize: "20px", margin: 0, color: "#37519d" }}
          >
            {message}
          </Text>
        )}
      </div>
    </div>
  );
};

export default RatingBox;
